// extracted by mini-css-extract-plugin
export var emoji = "style-module--emoji--7Zmj5";
export var root = "style-module--root--Ft2DX";